import { render } from "./initialHoldView.vue?vue&type=template&id=598e44d4&scoped=true&ts=true&lang=pug"
import script from "./initialHoldView.vue?vue&type=script&lang=ts&setup=true"
export * from "./initialHoldView.vue?vue&type=script&lang=ts&setup=true"

import "./initialHoldView.vue?vue&type=style&index=0&id=598e44d4&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-598e44d4"]])

export default __exports__